import { Nilable } from "@nahuelmorata/ngx-extras";

export interface IQuestionDTO{
    id: string;
    quality: string;
    void_percentage: number;
}

export class QuestionDTO{
    public id = "0";
    public quality = "";
    public voidPercentage = 0;

    constructor(json: Nilable<Partial<IQuestionDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }


    }
    cargarDTO(json: Partial<IQuestionDTO>) {
        if (json?.id != null) {
            this.id = json.id;
        }
        if (json?.quality != null) {
            this.quality = json.quality;
        }
        if (json?.void_percentage != null) {
            this.voidPercentage = json.void_percentage;
        }
    }
}